<iframe title="content" class="w-100 h-100" id="e360-plugin" name="e360-plugin" [src]="frameSource | safeUrl"></iframe>
